export const companiesQueryKeys = {
  withoutTeams: (companyId: string) =>
    [`companies/${companyId}`, { skipTeams: true }] as const
}

export const companiesMutationKeys = {
  identifier: (identifier: string) =>
    [`companies/${identifier}`, { method: 'patch' }] as const,
  authenticationPreferences: (identifier: string) =>
    [`companies/${identifier}/auth/prefs`, { method: 'post' }] as const,
  samlProperties: (identifier: string) =>
    [`companies/${identifier}/saml/props`, { method: 'post' }] as const
}
